import { CustomerStateCompanyType } from '../../../api/lending/edge';

export function getIsSoleTrader(companyType?: CustomerStateCompanyType) {
  return (
    companyType === 'sole_trader' ||
    companyType === 'ordinary_partnership' ||
    companyType === 'other'
  );
}
